import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { Field } from 'formik';

import ErrorIcon from '../../../assets/images/icon_error_messages.gif';
import request from '../../utils/request';
import Label from './common/label';

const Province = ({ labels, errors, touched }) => {
  const [provincesList, setProvincesList] = useState([]);

  useEffect(() => {
    request.get('/provinces').then(({ data: { provinces } }) => {
      setProvincesList(provinces);
    });
  }, []);

  return (
    <>
      <Label labelName={labels.SELECT_PROVINCE} />
      <div
        style={{
          position: 'relative',
          width: '100%',
          marginBottom: '-1.75rem'
        }}
        className={`frg-select-container color-light input-container ${
          errors.province && touched.province ? 'error' : ''
        }`}
      >
        <Field as="select" name="province" className="select-style">
          <option value />
          {provincesList &&
            provincesList.length > 0 &&
            provincesList.map(province => (
              <option value={province.id}>{province.name}</option>
            ))}
        </Field>
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.province}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div>
    </>
  );
};

Province.propTypes = {
  labels: PropTypes.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired
};

export default Province;
